/*
  When changing this file:
  
  1. just import new routes, and define them in the array.
  2. If you want to disable authentication, remove the `beforeEnter` property.
*/

import { createRouter, createWebHashHistory } from "vue-router";
//import { authAdmin, authUser, requestToken } from "@/helpers/AuthRouter";
import store from "@/store";
import { ENVIRONMENTS } from "@/helpers/GameConstants";

import AdminView from "@/views/AdminView";
import ReferenceDataView from "@/views/ReferenceDataView";
import GameView from "@/views/GameView.vue";

const routes = [
  {
    path: "/",
    redirect: "/reference-data"
  },
  {
    path: "/reference-data",
    name: "ReferenceData",
    component: ReferenceDataView,
    beforeEnter: authUser
  },
  {
    path: "/game/:environment?", // optional parameter
    name: "Game",
    props: true,
    component: GameView,
    beforeEnter: [authUser, validateEnvironment]
  },
  {
    path: "/admin",
    name: "Admin",
    component: AdminView,
    beforeEnter: [authUser, authAdmin]
  }
];
function isValidEnvironment(environment) {
  return Object.values(ENVIRONMENTS).includes(environment);
}

function validateEnvironment(to, _from, next) {
  const { environment } = to.params;
  if (!environment || !isValidEnvironment(environment)) {
    // Redirect to default environment
    next({ path: `/game/${ENVIRONMENTS.WETLAND}` });
  } else {
    // Proceed with the navigation
    next();
  }
}

function authAdmin(_to, _from, next) {
  if (!store.getters.isAdmin) {
    console.warn("NOT ADMIN");
    return;
  }
  next();
}

function authUser(to, _from, next) {
  if (!store.getters.shouldDoAuth) {
    console.warn("No Auth");
    // continue to the next route if auth is not required
    next();
    return;
  }

  if (!store.getters.publicKey) {
    console.warn("No Public Key");
    return;
  }

  if (to.query) {
    if (to.query.jwt) {
      store.dispatch("setToken", to.query.jwt);
      delete to.query.jwt;
      router.replace(to);
    }
  }

  if (store.getters.getToken) {
    if (store.getters.isAuthenticated) {
      next();
    } else {
      requestToken();
    }
  } else {
    requestToken();
  }
}

function requestToken() {
  let originalQuery =
    window.location.href.split("?").length > 1
      ? window.location.href.split("?")[1]
      : "";

  // Redirect the user back to the current page
  const redirect = window.location.href.split("?")[0];

  // Create the params needed by the auth endpoint
  const params = {
    public_key: store.getters.publicKey,
    query: originalQuery,
    redirect: redirect
  };

  const query = new URLSearchParams(Object.entries(params));
  query.toString();

  // Redirect the user to the auth endpoint

  window.location.href =
    `https://courses.ecampus.oregonstate.edu/services/auth/public/v1/token` +
    "?" +
    query;
}

/*
 *
 * https://router.vuejs.org/guide/essentials/history-mode.html#hash-mode
 *
 * We use hash mode (createWebHashHistory), instead of
 * html5 mode (createWebHistory) so that it works on our S3 deployments.
 * The html5 mode is more SEO-friendly, but that isn't a concern with our
 * applications.
 */
/*
 * The 'linkExactActiveClass' is intended to style any router-view which
 * connects to the active view with the bold. It primarily will appear
 * in the `navbar`, but it will also bold any router-views, including buttons.
 */
const router = createRouter({
  mode: "history",
  linkExactActiveClass: "fw-bold",
  history: createWebHashHistory(process.env.BASE_URL),
  routes
});

export default router;
